module.exports = __webpack_public_path__ + "img/img016.4eee0937.png";